import { Editor } from '@monaco-editor/react';
import { DataViewProps } from '../common/DataView';
import { useState } from 'react';

const CCEditor = (
  props: DataViewProps<string> & {
    language: string
  }
) => {

  return (
    <Editor
      height="100%" width="100%" 
      language={ props.language }
      theme='vs-dark'
      value={ props.data || '' }
      onChange={(value) => props.setData(value || '')}
      options={{
        selectOnLineNumbers: true,
        minimap: { enabled: false },
      }}
    />
  );

};

export default CCEditor;